import validator from "validator";



export const validate_benefit = (data, t) => {
  if (
    validator.isEmpty(data.name) ||
    Number.isNaN(data.creationYear) ||
    Number.isNaN(data.spComponentId) ||
    Number.isNaN(data.spFunctionId) ||
    Number.isNaN(data.spGuaranteeId)
  ) {
    return t('benefit.input_required');
  }
  return '';
}

export const clean_benefit = (data) => {
  return {
    ...data,
    name: validator.trim(data.name),
    adminInstitution: validator.trim(data.adminInstitution),
    schemeName: validator.trim(data.schemeName),
    responsibleBody: validator.trim(data.responsibleBody),
    description: validator.trim(data.description),
    legalFramework: validator.trim(data.legalFramework),
  }
}